import React, { useContext, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { labelDefaultList } from '../../helpers/utils';
import { Overview } from './Overview';
import { addAppConfig, getAppConfig } from 'services/appConfigService';
import { LabelForm } from 'hooks/useLabelForm';
import { useModal } from 'hooks/useModal';
import { toast } from 'react-toastify';
import AppContext from 'context/Context';
import { FaList, FaCog, FaPaperPlane, FaRegSave, FaTimes, FaPlus } from 'react-icons/fa';
import { CustomPopover } from 'hooks/usePopover';
import { PhonesNumber } from 'components/phonesNumber/phonesNumber';
import EmojiPicker from 'emoji-picker-react';
import { BsEmojiSmileFill } from 'react-icons/bs';
import { PhonesNumberSend } from 'components/phonesNumber/phonesNumberSend';
import { Templates } from 'hooks/useMessagingTemplates';
import { addTemplates } from 'services/templatesService';

const AbandonedFormLayout = ({ attempt = 0 }) => {
    const allowedGSMChars = `@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà^|€{}[]~`;
    const [isSpecialChar, setIsSpecialChar] = useState(true);
    const [attemptId, setAttemptId] = useState(attempt);
    const [valuesConfig, setValuesConfig] = useState({ timeUnit: 1, message: '', senderID: 'sendmuleCX', delay: 1, channelProvider: '', active: true, });
    const { message, senderID, delay, timeUnit, } = valuesConfig;
    const [labels] = useState([...labelDefaultList]);
    const [messageInfo, setMessageInfo] = useState({
      length: 0,
      count: 0
    });
    const [isLoading, setIsLoading] = useState(false);
    const [toggleConfigMessages, CenteredModalConfigMessages] = useModal(false);
    const [toggleConfigPhones, CenteredModalConfigPhones] = useModal(false);
    const [toggleSendPhones, CenteredModalSendPhones] = useModal(false);
    const [labelSelected, setLabelSelected] = useState([]);
    const [validated, setValidated] = useState(false);
    const [loadAgain, setLoadAgain] = useState(false);

    const [messageEdit, setMessageEdit] = useState(null);
    const [sendingTemplate, setSendingTemplate] = useState(false);

    const {
        setBreadcrumbs
    } = useContext(AppContext);        

    useEffect(() => {
        setBreadcrumbs('');
        try {        
          getData();    
        } catch (error) {
          setIsLoading(false);
        }
      }, [attemptId]);

    const getData = async () => {

        if(attemptId === 0) {
            setValuesConfig({ timeUnit: 1, message: '', senderID: 'sendmuleCX', delay: 1, channelProvider: '', active: false });
            return;
        }

        try {
            setIsLoading(true);
            var result = await getAppConfig(attemptId);
            const { attemptsConfig } = result.data;
    
            if (attemptsConfig.length > 0) {
                const { senderID, delay, timeUnit, messageTemplate, channelProvider, active } = attemptsConfig[0];
                setValuesConfig({...valuesConfig, senderID, delay: delay || 1, timeUnit: timeUnit || 1, message: messageTemplate || '', channelProvider, active});
    
                if (messageTemplate) {
                  processMessage(messageTemplate);
                }
            }
        } catch (error) {
            toast.error(`Error loading data.`, {
                theme: 'colored'
            });
        } finally {
            setIsLoading(false);
        }    
    };

    const isSpecialCharacters = (msn) => {
        const regexCharacters = /[ÁáÉéÍíÓóÚúÑñüÜ!¡@#$%^&*=,;:\-¿?_<>/]/g;
        let characteres = msn.match(regexCharacters);
  
        if (!!characteres) {
          return true;
        }
  
        const regexEmojic = /[😀|😁|😂|🤣|😃|😄|😅|😆|😉|😊|😋|😎|😍|😘|😗|😙|😚|🙂|🤗|🤔|😐|😑|😶|🙄|😏|😣|😥|😮|🤐|😯|😪|😫|😴|😌|😛|😜|😝|🤤|😒|😓|😔|😕|🙃|🤑|😲|☹|🙁|😖|😞|😟|😤|😢|😭|😦|😧|😨|😩|😬|😰|😱|😳|😵|😡|😠|😷|🤒|🤕|🤢|🤧|😇|🤠|🤡|🤥|🤓|😈|👿|👹|👺|💀|👻|👽|🤖|💩|😺|😸|😹|😻|😼|😽|🙀|😿|😾|👶|👧|👦|👩|👨|👵|👴|👲|👳‍♀|👳‍♂|👱‍♂|👱‍♀|👮‍♀|👮‍♂|👷‍♀|👷‍♂|💂‍♀|💂‍♂|🕵‍♀|🕵‍♂|👩‍⚕|👨‍⚕|👩‍🌾|👨‍🌾|👩‍🍳|👨‍🍳|👩‍🎓|👨‍🎓|👩‍🎤|👨‍🎤|👩‍🏫|👨‍🏫|👩‍🏭|👨‍🏭|👩‍💻|👨‍💻|👩‍💼|👨‍💼|👩‍🔧|👨‍🔧|👩‍🔬|👨‍🔬|👩‍🎨|👨‍🎨|👩‍🚒|👨‍🚒|👨‍✈|👩‍🚀|👨‍🚀|👩‍⚖|👨‍⚖|👰|🤵|👸|🤴|🤶|🎅|👼|🤰|🙇‍♀|🙇‍♂|💁‍♀|💁‍♂|🙅‍♀|🙅‍♂|🙆‍♀|🙆‍♂|🙋‍♀|🙋‍♂|🤦‍♀|🤦‍♂|🤷‍♀|🤷‍♂|🙎‍♀|🙎‍♂|🙍‍♀|🙍‍♂|💇‍♀|💇‍♂|💆‍♀|💆‍♂|💅|🤳|💃|🕺|👯‍♀|👯‍♂|🕴|🚶‍♀|🚶‍♂|🏃‍♀|🏃‍♂|👫|👭|👬|💑|👩‍❤‍👩|👨‍❤‍👨|💏|👩‍❤‍💋‍👩|👨‍❤‍💋‍👨|👪|👨‍👩‍👧|👨‍👩‍👧‍👦|👨‍👩‍👦‍👦|👨‍👩‍👧‍👧|👩‍👩‍👦|👩‍👩‍👧|👩‍👩‍👧‍👦|👩‍👩‍👦‍👦|👩‍👩‍👧‍👧|👨‍👨‍👦|👨‍👨‍👧|👨‍👨‍👧‍👦|👨‍👨‍👦‍👦|👨‍👨‍👧‍👧|👩‍👦|👩‍👧|👩‍👧‍👦|👩‍👦‍👦|👩‍👧‍👧|👨‍👦|👨‍👧|👨‍👧‍👦|👨‍👦‍👦|👨‍👧‍👧|👐|🙌|👏|🤝|👍|👎|👊|✊|🤛|🤜|🤞|✌|🤘|👌|👈|👉|👆|👇|☝|✋|🤚|🖐|🖖|👋|🤙|💪|🖕|✍|🙏|💍|💄|💋|👄|👅|👂|👃|👣|👁|👀|🗣|👤|👥|👚|👕|👖|👔|👗|👙|👘|👠|👡|👢|👞|👟|👒|🎓|⛑|👑|👝|👛|👜|💼|🎒|👓|🕶|🎩|🌂|👶🏻|👦🏻|👧🏻|👨🏻|👩🏻|👱🏻‍♀|👱🏻|👴🏻|👵🏻|👲🏻|👳🏻‍♀|👳🏻|👮🏻‍♀|👮🏻|👷🏻‍♀|👷🏻|💂🏻‍♀|💂🏻|🕵🏻‍♀|🕵🏻|👩🏻‍⚕|👨🏻‍⚕|👩🏻‍🌾|👨🏻‍🌾|👩🏻‍🍳|👨🏻‍🍳|👩🏻‍🎓|👨🏻‍🎓|👩🏻‍🎤|👨🏻‍🎤|👩🏻‍🏫|👨🏻‍🏫|👩🏻‍🏭|👨🏻‍🏭|👩🏻‍💻|👨🏻‍💻|👩🏻‍💼|👨🏻‍💼|👩🏻‍🔧|👨🏻‍🔧|👩🏻‍🔬|👨🏻‍🔬|👩🏻‍🎨|👨🏻‍🎨|👩🏻‍🚒|👨🏻‍🚒|👩🏻‍✈|👨🏻‍✈|👩🏻‍🚀|👨🏻‍🚀|👩🏻‍⚖|👨🏻‍⚖|🤶🏻🎅🏻|👸🏻|🤴🏻🙇🏻‍♀|🙇🏻|💁🏻|💁🏻‍♂|🙅🏻|🙅🏻‍♂|🙆🏻|🙆🏻‍♂|🙋🏻|🙋🏻‍♂|🤦🏻‍🙎🏻|🙎🏻‍♂|🙍🏻|🙍🏻‍♂|💇🏻|💇🏻‍♂|💆🏻|💆🏻‍♂|🕴🏻|💃🏻|🕺🏻|🚶🏻‍♀|🚶🏻|🏃🏻‍♀|🏃🏻|👐🏻|🙌🏻|👏🏻|🙏🏻|👍🏻|👎🏻|👊🏻|✊🏻|✌🏻🤘🏻|👌🏻|👈🏻|👉🏻|👆🏻|👇🏻|☝🏻|✋🏻|🤚|🖐🏻|🖖🏻|👋🏻|🤙|💪🏻|🖕🏻|💅🏻|👂🏻|👃🏻|👶🏾|👦🏾|👧🏾|👨🏾|👩🏾|👱🏾‍♀|👱🏾|👴🏾|👵🏾|👲🏾|👳🏾‍♀|👳🏾|👮🏾‍♀|👮🏾|👷🏾‍♀|👷🏾|💂🏾‍♀|💂🏾|🕵🏾‍♀|🕵🏾|👩🏾‍⚕|👨🏾‍⚕|👩🏾‍🌾|👨🏾‍🌾|👩🏾‍🍳|👨🏾‍🍳|👩🏾‍🎓|👨🏾‍🎓|👩🏾‍🎤|👨🏾‍🎤|👩🏾‍🏫|👨🏾‍🏫|👩🏾‍🏭|👨🏾‍🏭|👩🏾‍💻|👨🏾‍💻|👩🏾‍💼|👨🏾‍💼|👩🏾‍🔧|👨🏾‍🔧|👩🏾‍🔬|👨🏾‍🔬|👩🏾‍🎨|👨🏾‍🎨|👩🏾‍🚒|👨🏾‍🚒|👩🏾‍✈|👨🏾‍✈|👩🏾‍🚀|👨🏾‍🚀|👩🏾‍⚖|👨🏾‍⚖|🤶🏾|🎅🏾|👸🏾|🤴🏾|👰|👼🏾|🤰🏾|🙇🏾‍♀|🙇🏾|💁🏾|💁🏾‍♂|🙅🏾|🙅🏾‍♂|🙆🏾|🙆🏾‍♂|🙋🏾|🙋🏾‍♂|🤦🏾‍🏾‍♂|🙎🏾|🙎🏾‍♂|🙍🏾|🙍🏾‍♂|💇🏾|💇🏾‍♂|💆🏾|💆🏾‍♂|🕴🏾|💃🏾|🕺🏾|🚶🏾‍♀|🚶🏾|🏃🏾‍♀|🏃🏾|👐🏾|🙌🏾|👏🏾|🙏🏾|👍🏾|👎🏾|👊🏾|✊🏾|🤛🏾🤜|✌🏾🤘🏾|👌🏾|👈🏾|👉🏾|👆🏾|👇🏾|☝🏾|✋🏾|🤚🏾|🖐🏾|🖖🏾|👋🏾|🤙🏾|💪🏾|🖕🏾|✍🏾|🤳🏾💅🏾|👂🏾|👃🏾|🐶|🐱|🐭|🐹|🐰|🦊|🐻|🐼|🐨|🐯|🦁|🐮|🐷|🐽|🐸|🐵|🙈|🙉|🙊|🐒|🐔|🐧|🐦|🐤|🐣|🐥|🦆|🦅|🦉|🦇|🐺|🐗|🐴|🦄|🐝|🐛|🦋|🐌|🐚|🐞|🐜|🕷|🕸|🦂|🐢|🐍|🦎|🐙|🦑|🦐|🦀|🐡|🐠|🐟|🐬|🐳|🐋|🦈|🐊|🐅|🐆|🦍|🐘|🦏|🐪|🐫|🐃|🐂|🐄|🐎|🐖|🐏|🐑|🐐|🦌|🐕|🐩|🐈|🐓|🦃|🕊|🐇|🐁|🐀|🐿|🐾|🐉|🐲|🌵|🎄|🌲|🌳|🌴|🌱|🌿|☘|🍀|🎍|🎋|🍃|🍂|🍁|🍄|🌾|💐|🌷|🌹|🥀|🌺|🌸|🌼|🌻|🌞|🌝|🌛|🌜|🌚|🌖|🌗|🌘|🌑|🌒|🌓|🌔|🌙|🌎|🌍|🌏|💫|⭐|🌟|✨|⚡|☄|💥|🔥|🌪|🌈|☀|🌤|⛅|🌥|☁|🌦|🌧|⛈|🌩|🌨|❄|☃|⛄|🌬|💨|💧|💦|☔|☂|🌊|🌫|🍏|🍎|🍐|🍊|🍋|🍌|🍉|🍇|🍓|🍈|🍒|🍑|🍍|🥝|🍅|🍆|🥑|🥒|🌶|🌽|🥕|🥔|🍠|🥐|🍞|🥖|🧀|🥚|🍳|🥞|🥓|🍗|🍖|🌭|🍔|🍟|🍕|🥙|🌮|🌯|🥗|🥘|🍝|🍜|🍲|🍛|🍣|🍱|🍤|🍙|🍚|🍘|🍥|🍢|🍡|🍧|🍨|🍦|🍰|🎂|🍮|🍭|🍬|🍫|🍿|🍩|🍪|🌰|🥜|🍯|🥛|🍼|☕|🍵|🍶|🍺|🍻|🥂|🍷|🥃|🍸|🍹|🍾|🥄|🍴|🍽|⚽|🏀|🏈|⚾|🏐|🏉|🎾|🎱|🏓|🏸|🥅|🏒|🏑|🏏|⛳|🏹|🎣|🥊|🥋|🎽|⛸|🎿|⛷|🏂|🏋‍♀|🏋🏻‍♀|🏋🏼‍♀|🏋🏽‍♀|🏋🏾‍♀|🏋🏿‍♀|🏋‍♂|🏋🏻‍♂|🏋🏼‍♂|🏋🏽‍♂|🏋🏾‍♂|🏋🏿‍♂|🤼‍♀|🤼‍♂|🤸‍♀|🤸🏻‍♀|🤸🏼‍♀|🤸🏽‍♀|🤸🏾‍♀|🤸🏿‍♀|🤸‍♂|🤸🏻‍♂|🤸🏼‍♂|🤸🏽‍♂|🤸🏾‍♂|🤸🏿‍♂|⛹‍♀|⛹🏻‍♀|⛹🏼‍♀|⛹🏽‍♀|⛹🏾‍♀|⛹🏿‍♀|⛹‍♂|⛹🏻‍♂|⛹🏼‍♂|⛹🏽‍♂|⛹🏾‍♂|⛹🏿‍♂|🤺|🤾‍♀|🤾🏻‍♀|🤾🏼‍♀|🤾🏾‍♀|🤾🏾‍♀|🤾🏿‍♀|🤾‍♂|🤾🏻‍♂|🤾🏼‍♂|🤾🏽‍♂|🤾🏾‍♂|🤾🏿‍♂|🏌‍♀|🏌🏻‍♀|🏌🏼‍♀|🏌🏽‍♀|🏌🏾‍♀|🏌🏿‍♀|🏌‍♂|🏌🏻‍♂|🏌🏼‍♂|🏌🏽‍♂|🏌🏾‍♂|🏌🏿‍♂|🏇|🏇🏻|🏇🏼|🏇🏽|🏇🏾|🏇🏿|🏄‍♀|🏄🏻‍♀|🏄🏼‍♀|🏄🏽‍♀|🏄🏾‍♀|🏄🏿‍♀|🏄‍♂|🏄🏻‍♂|🏄🏼‍♂|🏄🏽‍♂|🏄🏾‍♂|🏄🏿‍♂|🏊‍♀|🏊🏻‍♀|🏊🏼‍♀|🏊🏽‍♀|🏊🏾‍♀|🏊🏿‍♀|🏊‍♂|🏊🏻‍♂|🏊🏼‍♂|🏊🏽‍♂|🏊🏾‍♂|🏊🏿‍♂|🤽‍♀|🤽🏻‍♀|🤽🏼‍♀|🤽🏽‍♀|🤽🏾‍♀|🤽🏿‍♀|🤽‍♂|🤽🏻‍♂|🤽🏼‍♂|🤽🏽‍♂|🤽🏾‍♂|🤽🏿‍♂|🚣‍♀|🚣🏻‍♀|🚣🏼‍♀|🚣🏽‍♀|🚣🏾‍♀|🚣🏿‍♀|🚣‍♂|🚣🏻‍♂|🚣🏼‍♂|🚣🏽‍♂|🚣🏾‍♂|🚣🏿‍♂|🚵‍♀|🚵🏻‍♀|🚵🏼‍♀|🚵🏽‍♀|🚵🏾‍♀|🚵🏿‍♀|🚵‍♂|🚵🏻‍♂|🚵🏼‍♂|🚵🏽‍♂|🚵🏾‍♂|🚵🏿‍♂|🚴‍♀|🚴🏻‍♀|🚴🏼‍♀|🚴🏽‍♀|🚴🏾‍♀|🚴🏿‍♀|🚴‍♂|🚴🏻‍♂|🚴🏼‍♂|🚴🏾‍♂|🚴🏿‍♂|🏆|🥇|🥈|🥉|🏅|🎖|🏵|🎗|🎫|🎟|🎪|🤹‍♀|🎭|🎨|🎬|🎤|🎧|🎼|🎹|🥁|🎷|🎺|🎸|🎻|🎲|♟|🎯|🎳|🎮|🎰|🚗|🚕|🚙|🚌|🚎|🏎|🚓|🚑|🚒|🚐|🚚|🚛|🚜|🛴|🚲|🛵|🏍|🚨|🚔|🚍|🚘|🚖|🚡|🚠|🚟|🚃|🚋|🚞|🚝|🚄|🚅|🚈|🚂|🚆|🚇|🚊|🚉|✈|🛫|🛬|🛩|💺|🛰|🚀|🚁|🛶|⛵|🚤|🛥|🛳|⛴|🚢|⚓|⛽|🚧|🚦|🚥|🚏|🗺|🗿|🗽|🗼|🏰|🏯|🏟|🎡|🎢|🎠|⛲|⛱|🏖|🏝|🏜|🌋|🏔|🗻|🏕|🏠|🏡|🏘|🏚|🏗|🏭|🏢|🏬|🏣|🏤|🏥|🏦|🏨|🏪|🏫|🏩|💒|🏛|⛪|🕌|🕋|⛩|🛤|🛣|🗾|🎑|🏞|🌅|🌄|🌠|🎇|🎆|🌇|🌆|🏙|🌃|🌌|🌉|🌁|⌚|📱|📲|💻|⌨|🗜|💽|💾|💿|📀|📼|📷|📸|📹|🎥|📽|🎞|📞|☎|📟|📠|📺|📻|⏱|⏲|⏰|🕰|⌛|⏳|📡|🔋|🔌|💡|🔦|🛢|💸|💵|💴|💶|💷|💰|💳|💎|⚖|🔧|🔨|⚒|🛠|⛏|🔩|⚙|⛓|🔫|💣|🔪|🗡|⚔|🚬|🏺|🔮|📿|💈|⚗|🔭|🔬|🕳|💊|💉|🌡|🚽|🚰|🚿|🛁|🛀|🛀🏻|🛀🏼|🛀🏽|🛀🏾|🛀🏿|🛎|🔑|🗝|🚪|🛋|🛏|🛌|🖼|🛍|🛒|🎁|🎈|🎏|🎀|🎊|🎉|🎎|🏮|🎐|✉|📩|📨|📧|💌|📥|📤|📦|🏷|📪|📫|📬|📭|📮|📯|📜|📃|📄|📑|📊|📈|📉|🗓|📆|📅|📇|🗃|🗳|🗄|📋|📁|📂|🗂|🗞|📰|📓|📔|📒|📕|📗|📘|📙|📚|📖|🔖|🔗|📎|🖇|📐|📏|📌|📍|✂|🖊|🖋|✒|🖌|🖍|📝|✏|🔍|🔎|🔏|🔐|🔒|🔓|❤|💛|💚|💙|💜|🖤|💔|❣|💕|💞|💓|💗|💖|💘|💝|💟|🕎|☯|☦|🛐|🆔|⚛|🉑|☢|☣|📴|📳|🆚|🆑|🅾|🆘|⛔|📛|🚫|💯|💢|♨|🚷|🚯|🚳|🚱|🔞|📵|🚭|🔅|🔆|🚸|🔱|⚜|🔰|♻|🈯|💹|❎|🌐|💠|🌀|💤|🏧|🚾|♿|🛂|🛃|🛄|🛅|🚹|🚺|🚼|🚻|🚮|🎦|📶|🈁|🔣|🔤|🔡|🔠|🔂|🔄|🔃|🎵|🎶|🔚|🔙|🔛|🔝|🔜|🔈|🔇|🔉|🔊|🔔|🔕|📣|📢|👁‍🗨|💬|💭|🗯|♠|♣|♥|🎴|🕐|🕑|🕒|🕓|🕔|🕕|🕖|🕗|🕘|🕙|🕚|🕛|🕜|🕝|🕞|🕟|🕠|🕡|🕢|🕣|🕤|🕥|🕦|🕧]/g;
        characteres = msn.match(regexEmojic);
  
        if (!!characteres) {
          return true;
        }
  
        return false;
    }

    const processMessage = (msn) => {
        //const regex = /{([^}]*)}/g;
        const regexWord = /\[([\w\s]*)\]/g;
        const regexNonWord = /\[([\W]*)\]/g;
        var grupos;
        var gruposNonWord;
        let msns = [];
        
        while ((grupos = regexWord.exec(msn)) !== null) {
        //console.log("Llaves:", grupos[0], "\tPosición:", grupos.index, "\tColor:", grupos[1]);
        msns.push(['[', grupos[1], ']'].join(''));        
        }

        while ((gruposNonWord = regexNonWord.exec(msn)) !== null) {
        //console.log("Llaves:", grupos[0], "\tPosición:", grupos.index, "\tColor:", grupos[1]);
        msns.push(['[', gruposNonWord[1], ']'].join(''));        
        }

        const tally = {};
        const uniqueLabels = [];

        for(let i = 0; i < msns.length; i++) {
        if(tally.hasOwnProperty(msns[i])) {
            tally[msns[i]]++;
        } else {
            tally[msns[i]] = 1;
        }
        };

        for(let date in tally) {
        uniqueLabels.push(date);
        }

        const isSpecial = isSpecialCharacters(msn);
        let divide = Math.ceil(msn.length / (isSpecial ? 70 : 160));
        setMessageInfo({
        length: msn.length,
        count: divide
        });

        setLabelSelected([...uniqueLabels]);
    }

    const handleSubmit = async (e) => {
        try {
            const form = e.currentTarget;
            e.preventDefault();
            setValidated(false);

            if(attemptId === 0) {
                toast.warning(`Choose an attempt template to edit.`, {
                    theme: 'colored'
                });
                return;
            }

            if (form.checkValidity() === false) {
                e.stopPropagation();
                setValidated(true);
                return;
            }

            setIsLoading(true);
            const { senderID, message, delay, timeUnit, channelProvider, active } = valuesConfig;

            const result = await addAppConfig({
                attemptsConfig: [
                    {
                        number: attemptId,
                        senderID,
                        messageTemplate: message,
                        delay,
                        timeUnit: parseInt(timeUnit),
                        fields: [...labelSelected],
                        active,
                        channelProvider
                    }
                ]
            });
            setIsLoading(false);
            toast.success(`Data saving success.`, {
                theme: 'dark'
            });
            setLoadAgain(!loadAgain);
            onHandleCancel();
        } catch (error) {
            setIsLoading(false);
            const { response: { data: { errors } } } = error;
            toast.error(`Error saving data. ${errors || ''}`, {
                theme: 'colored'
            });
        }        
    };

    const useHandleChangeForm = ({ target }) => {      
        if (target.name === 'message') {
            let newValue = target.value;
            if (!isSpecialChar) {
                newValue = newValue.split('').filter(char => allowedGSMChars.includes(char)).join('');
            }
            processMessage(newValue);
            setValuesConfig({...valuesConfig, message: newValue});
        } else {
            setValuesConfig({...valuesConfig, [target.name]: target.value});
        }      
      };
    
    const onPushLabel = (lb) => {
        let input = document.getElementsByName('message')[0];
  
        if (document.selection) {
          input.focus();
          let sel = document.selection.createRange();
          sel.text = lb;
        } else if (input.selectionStart || input.selectionStart === '0') {
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + lb
                + input.value.substring(endPos, input.value.length);
        } else {
            input.value += lb;
        }
  
        processMessage(input.value);
        setValuesConfig({...valuesConfig, 'message': input.value});
    }

    const onHandleClickEdit = (num) => {
        setAttemptId(num);
        setMessageEdit(null);
    }

    const onHandleCancel = () => {
        setAttemptId(0);
        setValidated(false);
        setValuesConfig({ timeUnit: 1, message: '', senderID: 'sendmuleCX', delay: 1, channelProvider: '', active: true });
        setMessageInfo({ length: 0, count: 0 });
        setMessageEdit(null);
    }

    const messageSelected = (msn) => {
        setValuesConfig({...valuesConfig, message: msn});
        processMessage(msn);
        toggleConfigMessages();
        setMessageEdit(0);
    }

    const messageSelectedToEdit = (msn, index) => {
        setAttemptId(0);
        setValidated(false);

        setValuesConfig({ message: msn, timeUnit: 1, senderID: 'sendmuleCX', delay: 1, channelProvider: '', active: true });
        processMessage(msn);
        toggleConfigMessages();
        setMessageEdit(index);
        const element = document.getElementsByName('message')[0];
        window.setTimeout(() => element.focus(), 0);
    }

    const messageSelectedToAdd = (msn, index) => {
        setAttemptId(0);
        setValidated(false);

        setValuesConfig({ message: msn, timeUnit: 1, senderID: 'sendmuleCX', delay: 1, channelProvider: '', active: true });
        processMessage(msn);
        setMessageEdit(index);
        const element = document.getElementsByName('message')[0];
        window.setTimeout(() => element.focus(), 0);
    }

    const onSaveTemplate = async () => {
        try {
            var message = document.getElementsByName('message')[0].value;
            const isValid = message.trim().length !== 0;
            setSendingTemplate(true);
            if (isValid) {
                await addTemplates(JSON.stringify({
                    id: messageEdit,
                    message
                }));
                toast.success(`Template saved.`, {
                    theme: 'dark'
                });
                onHandleCancel();
            } else {
                toast.warning('Please enter a valid message', {
                    theme: 'colored',
                    className: 'bg-warning'
                });
            }
        } catch (error) {
            toast.error(`Error saving message template.`, {
                theme: 'colored'
            });
        } finally {
            setSendingTemplate(false);
        }
    }

    const renderModalConfigMessages = () => (
        <CenteredModalConfigMessages
          title={'Messages template'}
          footer={(
            <small className={`text-muted fst-italic`}>
                Choose a message template
            </small>
          )}
        >
            <Templates onMessageSelected={messageSelected} onMessageSelectedToEdit={messageSelectedToEdit} />
        </CenteredModalConfigMessages>
    );

    const renderModalConfigPhones = () => (
        <CenteredModalConfigPhones
          title={'My test numbers'}
          footer={(
            <small className={`text-muted fst-italic`}>
                You can add up to 5 phone numbers
            </small>
          )}
          size={'md'}
        >
            <PhonesNumber />
        </CenteredModalConfigPhones>
    );

    const renderModalSendPhones = () => (
        <CenteredModalSendPhones
            title={'Send test message'}
            size={'md'}
        >
            <PhonesNumberSend />
        </CenteredModalSendPhones>
    );

    const onEmojiClick = (emojiData, event) => {
        if (isSpecialChar) {
            onPushLabel(emojiData.emoji);
        }
    };

    const onActiveCharacters = ({ target }) => {
        setIsSpecialChar(target.checked);

        if (!target.checked) {
            let newValue = message;
            newValue = newValue.split('').filter(char => allowedGSMChars.includes(char)).join('');
            processMessage(newValue);
            setValuesConfig({...valuesConfig, message: newValue});
        }
    }

    return (
    <>
        <Row>
            <Col md={5} xs={12}>
                <FalconComponentCard>
                    <FalconComponentCard.Header title="Abandoned Cart Overview" light={false}  />
                        <FalconComponentCard.Body>
                            <Overview loadAgain={loadAgain} onClickEdit={onHandleClickEdit} attempt={attemptId} />
                        </FalconComponentCard.Body>
                </FalconComponentCard>
            </Col>
            <Col md={7} xs={12}>
                <FalconComponentCard>
                    <FalconComponentCard.Header title={`${(messageEdit !== null) ? 'Edit template': 'Message Composer'}`} light={false}  />
                    <FalconComponentCard.Body>
                        <Form noValidate validated={validated} onSubmit={handleSubmit} className={'animate__animated animate__fadeIn'}>
                            <Form.Group className="mb-3" controlid="senderID">
                                <Form.Label controlid="senderID">Sender ID</Form.Label>
                                <Form.Control 
                                    name="senderID"
                                    readOnly
                                    placeholder="Up to 11 characters" 
                                    size='sm' 
                                    onChange={useHandleChangeForm}
                                    //readOnly={[2,3].includes(attemptId)} 
                                    //disabled={[0,2,3].includes(attemptId)} 
                                    disabled
                                    value={'sendmuleCX'} 
                                />
                                <Form.Control.Feedback type="invalid">Please provide a valid sender.</Form.Control.Feedback>           
                            </Form.Group>
                            <Form.Group className="mb-3" controlid="message">
                                <Form.Label controlid="message">Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    required
                                    placeholder="Type message here"
                                    style={{ height: '100px' }}
                                    onChange={useHandleChangeForm}
                                    name={'message'}
                                    value={message}
                                    size='sm'
                                />
                                <Form.Control.Feedback type="invalid">Please provide a valid message template.</Form.Control.Feedback>
                        
                                <Row className="g-2">
                                    <Col>
                                        <Form.Text id="mutedMessage" muted>
                                            [<strong>{messageInfo.length}</strong>] characters used approx, [<strong>{messageInfo.count}</strong>] SMS messages.
                                        </Form.Text>
                                    </Col>
                                    <Col md className='d-flex justify-content-end' style={{alignItems: 'baseline'}}>
                                        <CustomPopover body={`${isSpecialChar ? 'Inactive' : 'Active'} Characters`}>
                                            <Form.Check 
                                                type='switch'
                                                id={`checkedCharSwitch`}
                                                label=''
                                                defaultChecked={isSpecialChar}
                                                onClick={onActiveCharacters}
                                            />
                                        </CustomPopover>
                                        {
                                            (messageEdit === null) && (
                                                <CustomPopover body={'Add template'}>
                                                    <Button size='sm' variant="light" className="justify-content-end mt-2" onClick={() => messageSelectedToAdd('', 0)}>
                                                        <FaPlus />
                                                    </Button>
                                                </CustomPopover>
                                            )
                                        }
                                        {
                                            (messageEdit !== null) && (
                                                <>
                                                    <CustomPopover body={'Discard'}>
                                                        <Button size='sm' variant="light" className="justify-content-end mt-2" onClick={onHandleCancel}>
                                                            <FaTimes />
                                                        </Button>
                                                    </CustomPopover>
                                                    <CustomPopover body={'Save'}>
                                                        <Button size='sm' variant="light" className="justify-content-end mt-2" onClick={onSaveTemplate}>
                                                            {
                                                                sendingTemplate ?
                                                                    <Spinner animation="grow" size="sm" style={{verticalAlign:'middle', height:'1rem', width:'1rem'}} />
                                                                :
                                                                    <FaRegSave />
                                                            }
                                                        </Button>
                                                    </CustomPopover> 
                                                </>
                                            )
                                        }                           
                                        {
                                            isSpecialChar && (
                                                <CustomPopover className={'animate__animated animate__fadeIn'} body={<EmojiPicker onEmojiClick={onEmojiClick} />} trigger={'click'} styles={{maxWidth: 'initial'}} placement={'left'}>
                                                    <Button size='sm' variant="light" className="mt-2" style={{color: 'var(--falcon-colored-link-hover-color-warning)'}}>
                                                        <BsEmojiSmileFill />
                                                    </Button>
                                                </CustomPopover>
                                            )
                                        }                                         
                                        <CustomPopover body={'show messaging templates'}>
                                            <Button size='sm' variant="light" className="justify-content-end mt-2" onClick={toggleConfigMessages}>
                                                <FaList />
                                            </Button>
                                        </CustomPopover>
                                        <CustomPopover body={'Configure phone numbers'}>  
                                            <Button size='sm' variant="light" className="mt-2" onClick={toggleConfigPhones}>
                                                <FaCog />
                                            </Button>
                                        </CustomPopover> 
                                        <CustomPopover body={'Sent message test'}>
                                            <Button size='sm' variant="light" className="mt-2" onClick={toggleSendPhones}>
                                                <FaPaperPlane />
                                            </Button>
                                        </CustomPopover>           
                                    </Col>
                                </Row>      
                            </Form.Group>
                                <Form.Group className='mb-3'>
                                    <LabelForm labels={labels} onPushLabel={onPushLabel} />
                                </Form.Group>
                            <Form.Group className='mb-3'>
                                <Row className="g-2">
                                    <Col md>
                                        <Form.Label controlid="delay">Send after</Form.Label>
                                        <Form.Control name="delay" onChange={useHandleChangeForm} type="number" min={1} required value={delay} size='sm' disabled={[0].includes(attemptId)} />
                                        <Form.Control.Feedback type="invalid">Please provide a valid delay number.</Form.Control.Feedback>
                                    </Col>
                                    <Col md>
                                        <Form.Label controlid="timeUnit">Time unit</Form.Label>
                                        <Form.Select aria-label="Floating label select example" onChange={useHandleChangeForm} name="timeUnit" value={timeUnit} size='sm' disabled={[0].includes(attemptId)}>
                                            <option value="3">Days</option>
                                            <option value="1">Hours</option>
                                            <option value="2">Minutes</option>
                                        </Form.Select>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                {
                                    isLoading && 
                                    (
                                        <Spinner animation="grow" className="position-absolute start-50" variant="primary" style={{marginRight:10, verticalAlign:'middle', height:'1.82rem', width:'1.82rem'}} /> 
                                    )
                                }
                                <div className="float-end align-middle">                                    
                                    <Button variant="secondary" size='sm' className='me-2' onClick={onHandleCancel}>Cancel</Button>
                                    <Button variant="primary" size='sm' type="submit" disabled={isLoading || [0].includes(attemptId)}>Save</Button>
                                </div>        
                            </Form.Group>                    
                        </Form>
                    </FalconComponentCard.Body>
                </FalconComponentCard>
            </Col>            
        </Row>
        {renderModalConfigMessages()}
        {renderModalConfigPhones()}
        {renderModalSendPhones()}
    </>
  );                
}

export default AbandonedFormLayout;